import { Heading4 } from "@/components/text/Heading4";

export function BlogHeading4({ children }: { children: React.ReactNode }) {
  return (
    <Heading4 elementType="h4" className="mb-4">
      {children}
    </Heading4>
  );
}
